// src/components/common/StaticFooter.jsx
import React from "react";
import { Box, Paper, Typography } from "@mui/material";

export default function StaticFooter({ children, title, sx = {} }) {
    return (
        <Paper
            elevation={8}
            sx={{
                width: '100%',
                borderTop: 2,
                borderColor: 'divider',
                bgcolor: 'background.paper',
                ...sx
            }}
        >
            {title && (
                <Box
                    sx={{
                        py: 1.5,
                        px: 2,
                        bgcolor: 'action.hover',
                        borderBottom: 1,
                        borderColor: 'divider'
                    }}
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {title}
                    </Typography>
                </Box>
            )}
            <Box sx={{ p: 3 }}>
                {children}
            </Box>
        </Paper>
    );
}